import { helpdeskRoutes } from '../routes/helpdeskRoutes';

export type HelpdeskHomeScreen = 'dashboard' | 'workspace' | 'inbox' | 'contacts';

export const HELPDESK_HOME_SCREEN_OPTIONS: Array<{
  value: HelpdeskHomeScreen;
  label: string;
  description: string;
  icon: string;
}> = [
  {
    value: 'dashboard',
    label: 'Dashboard',
    description: 'Visão geral e ações rápidas',
    icon: 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6',
  },
  {
    value: 'workspace',
    label: 'Atendimento',
    description: 'Fila e conversas em atendimento',
    icon: 'M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z',
  },
  {
    value: 'inbox',
    label: 'Minhas notificações',
    description: 'Conversas das suas caixas',
    icon: 'M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4',
  },
];

export const DEFAULT_HELPDESK_HOME_SCREEN: HelpdeskHomeScreen = 'workspace';

export const isHelpdeskHomeScreen = (value: unknown): value is HelpdeskHomeScreen => {
  return value === 'dashboard'
    || value === 'workspace'
    || value === 'inbox'
    || value === 'contacts';
};

export const normalizeHelpdeskHomeScreen = (value: unknown): HelpdeskHomeScreen => {
  if (isHelpdeskHomeScreen(value))
  {
    return value;
  }

  return DEFAULT_HELPDESK_HOME_SCREEN;
};

export const resolveHelpdeskHomePath = (screen: HelpdeskHomeScreen): string => {
  switch (screen)
  {
    case 'dashboard':
      return helpdeskRoutes.dashboard;
    case 'inbox':
      return helpdeskRoutes.inbox;
    case 'contacts':
      return helpdeskRoutes.contacts;
    case 'workspace':
    default:
      return helpdeskRoutes.workspace;
  }
};
